export default __webpack_public_path__ + "static/media/avatar_bg_minato.9eaf3bbd.png";